/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_VestingTranche_VestingTrancheAddUpdateResponseDto } from '../models/Wealthlane_AwardService_Dtos_VestingTranche_VestingTrancheAddUpdateResponseDto';
import type { Wealthlane_AwardService_Dtos_VestingTranche_VestingTrancheImportResponseDto } from '../models/Wealthlane_AwardService_Dtos_VestingTranche_VestingTrancheImportResponseDto';
import type { Wealthlane_AwardService_Dtos_VestingTranche_VestingTrancheSampleFileBlobDto } from '../models/Wealthlane_AwardService_Dtos_VestingTranche_VestingTrancheSampleFileBlobDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class VestingTrancheService {

    /**
     * @returns Wealthlane_AwardService_Dtos_VestingTranche_VestingTrancheSampleFileBlobDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppVestingTrancheDownloadOptionAwardSample(): CancelablePromise<Wealthlane_AwardService_Dtos_VestingTranche_VestingTrancheSampleFileBlobDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/vesting-tranche/download-option-award-sample',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_AwardService_Dtos_VestingTranche_VestingTrancheImportResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppVestingTrancheImportVestingTranche(
formData?: {
File?: Blob;
},
): CancelablePromise<Wealthlane_AwardService_Dtos_VestingTranche_VestingTrancheImportResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/vesting-tranche/import-vesting-tranche',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_AwardService_Dtos_VestingTranche_VestingTrancheAddUpdateResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppVestingTrancheImportTest(
formData?: {
File?: Blob;
},
): CancelablePromise<Wealthlane_AwardService_Dtos_VestingTranche_VestingTrancheAddUpdateResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/vesting-tranche/import-test',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
